import { render, staticRenderFns } from "./Volunteers.vue?vue&type=template&id=b5d07b60"
import script from "./Volunteers.vue?vue&type=script&lang=js"
export * from "./Volunteers.vue?vue&type=script&lang=js"
import style0 from "./Volunteers.vue?vue&type=style&index=0&id=b5d07b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports